<template>
  <!-- 收件箱 -->
  <div class="inbox_two">
    <div class="top_center">
      <div class="centers">
        <div class="inlbox flex">
          <div>
            <span class="co6e">您好，</span>{{ name }}
          </div>
          <!-- <div class="co6e meal center sz16">年刊</div> -->
        </div>
        <div class="titlee">可发送邮件数量: {{ sendEmailNum }}/{{ totleEmailNum }}</div>
        <div class="titlee">邮件：{{ unread.noReadNum }} 封未读邮件，{{ unread.starMarkNum }} 封星标邮件</div>
        <div class="flex">
          <div class="list center baff co00 sz16 cursor" @click="goroutr(1)">我的关注</div>
          <div class="list center baff co00 sz16 cursor" @click="goroutr(2)">发件箱</div>
          <div class="list center baff co00 sz16 cursor" @click="goroutr(3)">收件箱</div>
          <!-- <div class="list center baff co00 sz16">打开率</div> -->
          <!-- <div class="list center baff co00 sz16 position-re">
            <el-tooltip class="item" effect="dark" content="近一个月回复人数占比" placement="top">
              <i class="el-icon-warning-outline tips"></i>
            </el-tooltip>
            回复率
          </div> -->
          <div class="list center baff co00 sz16">合作联盟客</div>
        </div>
        <div class="flex">
          <div class="list_two center co6e font_bo sz18">{{ uniondetail.concernNum }}</div>
          <div class="list_two center co6e font_bo sz18">{{ uniondetail.sendEmailNum }}</div>
          <div class="list_two center co6e font_bo sz18">{{ uniondetail.receiveEmailNum }}</div>
          <!-- <div class="list_two center co6e font_bo sz18">{{ uniondetail.openRate }}%</div>
          <div class="list_two center co6e font_bo sz18">{{ uniondetail.replyRate }}%</div> -->
          <div class="list_two center co6e font_bo sz18">{{ uniondetail.cooperateNum }}</div>
        </div>
        <div class="contact baff ru5">
          <div class="center lately sz18 font_bo">最近联系人</div>
          <div class="lately_list flex cursor" v-for="(item, index) in recentContacts" :key="index"
            @click="gooubox(item.name)">
            <div class="lately_list_img flex ru50">
              <img class="ru50" :src="item.headSrc" alt="" />
            </div>
            <div class="text">
              <p class="sz18 text_one">{{ item.name }}</p>
              <p class="sz14 text_two">{{ item.defaultType }}</p>
            </div>
          </div>
        </div>
        <div class="seize"></div>
        <div class="flex cont">
          <div class="content_top center sz18 font_bo">建联数据概览</div>
          <div class="distribution center sz18 font_bo">联盟客地域分布</div>
        </div>
        <div class="flex tub">
          <div class="ecthc baff ru5 flex">
            <div class="charts">
              <div id="myChart1" :style="{ width: '100%', height: '100%' }"></div>
            </div>
            <div class="flex text center cursor">
              <el-dropdown trigger="click" @visible-change='iconclick'>
                <div class="text_tltle flex">
                  <img src="@/assets/img/emil/rl.png" alt="">
                  <p class="sz12">{{ before }}</p>
                  <i style="margin-left: 10px;" v-if="iconstuts" class="el-icon-caret-right"></i> <i
                    style="margin-left: 10px;" v-else class="el-icon-caret-bottom"></i>
                </div>
                <el-dropdown-menu style="margin-top: 40px;margin-left: -30px;" :visible-arrow="false" slot="dropdown">
                  <div class="nologins cursor">
                    <!-- <div class="nologins_title">选择周期</div> -->
                    <div class="nologins_list center cursor" :class="listStuts == 1 ? 'listba' : ''"
                      @click="listclick(1)">
                      过去7天 <i v-if="listStuts == 1" class="el-icon-check"></i></div>
                    <div class="nologins_list center cursor" :class="listStuts == 2 ? 'listba' : ''"
                      @click="listclick(2)">
                      过去30天 <i v-if="listStuts == 2" class="el-icon-check"></i></div>
                    <div class="nologins_list center cursor" :class="listStuts == 3 ? 'listba' : ''"
                      @click="listclick(3)">
                      过去90天 <i v-if="listStuts == 3" class="el-icon-check"></i></div>
                    <div class="nologins_list center cursor" :class="listStuts == 4 ? 'listba' : ''"
                      @click="listclick(4)">
                      过去1年 <i v-if="listStuts == 4" class="el-icon-check"></i></div>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <p class="text_icon"></p> -->
            </div>
          </div>
          <div class="ecthc_two baff ru5">
            <div class="ecthc_two_list flex">
              <p class="font_a center">NO</p>
              <p class="center">国家/地区</p>
              <p class="center">数量</p>
            </div>
            <div class="ecthc_two_list flex" v-for="(item, index1) in regionList" :key="index1">
              <p class="font_a center">{{ item.rank }}</p>
              <p class="center">{{ item.countryName }}</p>
              <p class="center">{{ item.sendNum }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <icp></icp> -->
  </div>
</template>
<script>
import { QUERYEMAILDATA, QUERYRECENTLYPERSON, QUERYALLIANCEAREA, QUERYNOREADSTARMARK, QUERYTOTALCOUNT, QUERY, QUERYMAINPERMIT, QUERYEMAILSENDANDTOTLENUM } from '../../api/emial'
import icp from '../icp/icp.vue'
export default {
  components: {
    icp
  },
  data() {
    return {
      before: "过去7天",
      listStuts: 1,
      newdatas: this.$moment().subtract(6, 'days').format('YYYY-MM-DD'),
      concernDatas: [],// 关注
      cooperateDatas: [],// 合作
      receiveDatas: [],// 收件
      sendDatas: [],// 发件
      xdatas: [], // 时间
      iconstuts: true,
      recentContacts: [],// 最近联系人
      regionList: [], // 地域分布
      unread: {}, // 未读 星标 (数量)
      uniondetail: {},
      name: '',
      icons: [
        require('@/assets/img/foll/1.png'),
        require('@/assets/img/foll/2.png'),
        require('@/assets/img/foll/3.png'),
        require('@/assets/img/foll/4.png'),
      ],
      validParam: localStorage.getItem('validParam'),
      queryMainPermitList: [],
      sendEmailNum: '',
      totleEmailNum: '',
    }
  },
  mounted() {
    if (this.validParam !== 'mc') {
      this.$bus.$emit('showNopermiss',true)
    }
    this.drawPie1()
    this.queryEmailData()
    this.queryRecentlyPerson()
    this.queryAllianceArea()
    this.queryNoReadStarMark()
    this.queryTotalCount()
    this.querylsi()
    this.queryMainPermit()
    this.queryEmailSendAndTotleNum()
  },
  methods: {
    // 获取登录信息
    querylsi() {
      QUERY().then(res => {
        if (res.data.code == 'nolog') {
          this.$router.push('./')
        } else if (res.data.code == 'forceout') {
          // this.$message({
          //   message: '账号在其他地方登录,您被迫下线',
          //   type: 'warning'
          // });
          localStorage.removeItem('token');
        } else {
          this.name = res.data.body.name
        }
      })
    },

    // 折线图数据
    queryEmailData() {
      QUERYEMAILDATA({
        dayDate: this.newdatas
      }).then(res => {
        this.concernDatas = res.data.body.concernDatas
        this.cooperateDatas = res.data.body.cooperateDatas
        this.receiveDatas = res.data.body.receiveDatas
        this.sendDatas = res.data.body.sendDatas
        this.xdatas = res.data.body.xDatas
        this.$nextTick(() => {
          this.drawPie1()
        })
      })
    },
    // 最近联系人
    queryRecentlyPerson() {
      QUERYRECENTLYPERSON().then(res => {
        this.recentContacts = res.data.body
      })
    },
    // 地域分布
    queryAllianceArea() {
      QUERYALLIANCEAREA().then(res => {
        this.regionList = res.data.body
      })
    },
    //邮件中心-未读邮件星标邮件（数量）
    queryNoReadStarMark() {
      QUERYNOREADSTARMARK().then(res => {
        this.unread = res.data.body
        localStorage.setItem('starMarkNum', res.data.body.starMarkNum)
      })
    },
    // 我的关注，发件箱，收件箱，打开率，回复率，合作联盟客(数值）
    queryTotalCount() {
      QUERYTOTALCOUNT().then(res => {
        this.uniondetail = res.data.body
      })
    },
    // 行业环形图数据处理
    drawPie1() {
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      let option = {
        tooltip: {
          trigger: 'item', //触发类型；轴触发，axis则鼠标hover到一条柱状图显示全部数据，item则鼠标hover到折线点显示相应数据，
          formatter: function (params) {
            return '建联数据：' + params.data
          },
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: true,
          orient: 'horizontal',
          x: 'left',      //可设定图例在左、右、居中
          y: 'top',     //可设定图例在上、下、居中
          textStyle: {
            fontSize: 12,
            rich: {
              a: {
                verticalAlign: 'middle',
              }
            },
            lineHeight: 22,
            padding: [0, -2, -2, 4],
          },
          itemGap: 40,
          // icon: "arrow", //rect ，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 15, //矩形宽度
          itemHeight: 15, //矩形高度
          data: [
            {
              name: '我的关注',
              icon: 'image://' + this.icons[3]//格式为'image://+icon文件地址'，其中image::后的//不能省略
            },
            {
              name: '发件箱',
              icon: 'image://' + this.icons[2]//格式为'image://+icon文件地址'，其中image::后的//不能省略
            },
            {
              name: '收件箱',
              icon: 'image://' + this.icons[0]//格式为'image://+icon文件地址'，其中image::后的//不能省略
            },
            {
              name: '合作联盟客',
              icon: 'image://' + this.icons[1]//格式为'image://+icon文件地址'，其中image::后的//不能省略
            }
          ],
          top: 4,
          left: 30
        },
        grid: {
          left: '3%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          boundaryGap: false,
          name: '时间',
          type: 'category',
          data: this.xdatas
        },
        yAxis: {
          name: '数量',
          type: 'value',
          minInterval: 1
        },
        series: [
          {
            name: '我的关注',
            type: 'line',
            symbolSize: 12,
            color: '#FC6780',
            data: this.concernDatas
          },
          {
            name: '发件箱',
            type: 'line',
            symbolSize: 12,
            color: '#FEC776',
            data: this.sendDatas
          },
          {
            name: '收件箱',
            type: 'line',
            symbolSize: 12,
            color: '#958AFF',
            data: this.receiveDatas
          },
          {
            name: '合作联盟客',
            type: 'line',
            symbolSize: 12,
            color: '#2CD4D3',
            data: this.cooperateDatas
          },
        ]
      };
      myChart.setOption(option);
    },
    // 选择周期
    listclick(e) {
      this.listStuts = e
      if (e == 1) {
        this.before = '过去7天'
        this.newdatas = this.$moment().subtract(6, 'days').format('YYYY-MM-DD')
        this.queryEmailData()
      } else if (e == 2) {
        this.before = '过去30天'
        this.newdatas = this.$moment().subtract(29, 'days').format('YYYY-MM-DD')
        this.queryEmailData()
      } else if (e == 3) {
        this.before = '过去90天'
        this.newdatas = this.$moment().subtract(89, 'days').format('YYYY-MM-DD')
        this.queryEmailData()
      } else if (e == 4) {
        this.before = '过去一年'
        this.newdatas = this.$moment().subtract(364, 'days').format('YYYY-MM-DD')
        this.queryEmailData()
      }
    },
    // 选择周期箭头
    iconclick() {
      this.iconstuts = !this.iconstuts
    },
    queryMainPermit() {
      QUERYMAINPERMIT().then(res => {
        this.queryMainPermitList = res.data.body
      })
    },
    queryEmailSendAndTotleNum() {
      QUERYEMAILSENDANDTOTLENUM().then(res => {
        this.sendEmailNum = res.data.body.sendEmailNum
        this.totleEmailNum = res.data.body.totleEmailNum
      })
    },
    // 路由跳转
    goroutr(e) {
      if (e == 1) {
        this.queryMainPermitList.map(item => {
          if (item.title == '我的关注') {
            if (item.isLock == 0) {
              localStorage.setItem('validParam', item.validParam)
              localStorage.setItem('validParam', item.validParam)
              this.$router.push({ path: '/demo', query: { r: 1 } })
            } else {
              this.$bus.$emit('showNopermiss',true)
            }
          }
        })
      } else if (e == 2) {
        this.queryMainPermitList.map(item => {
          if (item.permits) {
            item.permits.map(item => {
              if (item.title == '发件箱') {
                if (item.isLock == 0) {
                  localStorage.setItem('validParam', item.validParam)
                  this.$router.push({ path: '/demo', query: { r: 3 } })
                } else {
                  this.$bus.$emit('showNopermiss',true)
                }
              }
            })
          }
        })
      } else if (e == 3) {
        this.queryMainPermitList.map(item => {
          if (item.permits) {
            item.permits.map(item => {
              if (item.title == '收件箱') {
                if (item.isLock == 0) {
                  localStorage.setItem('validParam', item.validParam)
                  this.$router.push({ path: '/demo', query: { r: 2 } })
                } else {
                  this.$bus.$emit('showNopermiss',true)
                }
              }
            })
          }
        })
      }
    },
    // 跳转发件箱
    gooubox(e) {
      this.queryMainPermitList.map(item => {
        if (item.permits) {
          item.permits.map(item => {
            if (item.title == '发件箱') {
              if (item.isLock == 0) {
                localStorage.setItem('validParam', item.validParam)
                this.$router.push({ path: '/demo', query: { name: e, r: 4 } })
              } else {
                this.$bus.$emit('showNopermiss',true)
              }
            }
          })
        }
      })
    }
  },
  beforeDestroy() {
  },
}
</script>
<style lang="less" scoped>
.nologins {
  width: 160px;
  border-radius: 14px;

  .nologins_title {
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-bottom: 1px solid rgba(64, 64, 64, 0.25);
    padding-left: 7px;
  }

  .nologins_list {
    width: 100%;
    height: 42px;
    line-height: 42px;
    margin: 10px 0;
  }
}

.listba {
  // background:#a6a8bf;
  background: rgba(166, 168, 191, 0.25);
}

@media screen and (min-width: 1000px) and (max-width: 2000px) {
  .top_center {
    width: 1600px;

    margin: 0 auto;
  }
}

@media screen and (min-width: 2000px) and (max-width: 3000px) {
  .top_center {
    width: 1920px;
    margin: 0 auto;
  }
}

.inbox_two {
  padding-top: 112px;
  padding-left: 20Px;
  box-sizing: border-box;
  background: #fafafa;

  .top_center {
    .centers {
      width: 98%;
      height: 100vh;
      //   margin: 0 auto;
      position: relative;


      .position-re {
        position: relative;

        .tips {
          font-size: 17px;
          position: absolute;
          right: 8px;
          top: 8px;
          color: #7c6a6a;
          cursor: pointer;
        }
      }
    }

    .inlbox {
      width: 98%;
      font-size: 28px;

      .meal {
        width: 62px;
        height: 36px;
        line-height: 36px;
        background: rgba(190, 60, 110, 0.2);
        border-radius: 5px 5px 5px 5px;
        font-size: 16px;
        margin-left: 24px;
      }
    }

    .titlee {
      margin-top: 15px;
      margin-bottom: 22px;
    }

    .list {
      width: 186px;
      height: 70px;
      line-height: 70px;
      box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);
      margin-right: 30px;
    }

    .list_two {
      width: 186px;
      height: 70px;
      line-height: 70px;
      margin-right: 30px;
    }

    .contact {
      width: 246px;
      height: 300px;
      border: 1px solid #d8d8d8;
      position: absolute;
      right: 0;
      top: 15px;
      padding-top: 10px;

      div {
        width: 100%;
      }

      .lately {
        color: #232323;
        margin-bottom: 20px;
      }

      .lately_list {
        width: 100%;
        padding-left: 15px;
        margin-bottom: 24px;

        .lately_list_img {
          width: 40px;
          height: 40px;
          align-items: center;
          margin-right: 18px;

          img {
            width: 100%;
            // height: 100%;
          }
        }

        .text {
          .text_one {
            color: #232323;
          }

          .text_two {
            color: #777777;
          }
        }
      }
    }

    .seize {
      width: 100%;
      height: 1px;
      background: rgba(64, 64, 64, 0.24);
      margin-top: 120px;
    }

    .cont {
      margin: 14px 0 13px 0;
      justify-content: space-between;

      .content_top {
        width: 1130px;
        color: #1a173b;
        // margin-right: 38px;
      }

      .distribution {
        width: 374px;
      }
    }

    .tub {
      width: 100%;
      justify-content: space-between;

      .ecthc {
        width: 1128px;
        height: 380px;
        border: 1px solid #d8d8d8;
        position: relative;

        // padding-right: 10px;
        // box-sizing: content-box;
        .charts {
          width: 100%;
          height: 380px;
          box-sizing: content-box;
        }

        .text {
          width: 15%;
          height: 30px;
          padding-top: 50px;
          padding-left: 22px;
          position: absolute;
          right: 14px;
          top: -35px;

          .text_img {
            width: 34px;
            height: 30px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .text_tltle {
            height: 30px;
            line-height: 30px;
            // margin: 0 6px 0 6px;
            align-items: center;
            position: relative;

            img {
              width: 34px;
              height: 30px;
              margin-right: 5px;
              position: absolute;
              left: -10px;
            }

            p {
              min-width: 90px;
              padding-left: 30px;
              box-sizing: border-box;
            }
          }

          .text_icon {
            height: 30px;
            line-height: 30px;
          }
        }
      }

      .ecthc_two {
        width: 374px;
        height: 380px;
        border: 1px solid #d8d8d8;
        padding: 5px 0;

        .ecthc_two_list {
          width: 100%;
          height: 48px;
          line-height: 48px;
          border-bottom: 1px solid #d8d8d8;
          margin-bottom: 5px;

          p {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.el-popper[x-placement^="bottom"] {
  margin-right: -45px !important;
}
</style>